module.exports = __webpack_public_path__ + "61e6f2d6.svg";